export default __webpack_public_path__ + "static/media/tr_0.b68f4706.mp3";